module.exports = __webpack_public_path__ + "static/img/301_TO8_2004_og.dc0de56.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/301_TO8_2004_og.jpg
// module id = Semp
// module chunks = 0